import { render, staticRenderFns } from "./addEmployee.vue?vue&type=template&id=30bbca56&scoped=true&"
import script from "./addEmployee.vue?vue&type=script&lang=js&"
export * from "./addEmployee.vue?vue&type=script&lang=js&"
import style0 from "./addEmployee.vue?vue&type=style&index=0&id=30bbca56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bbca56",
  null
  
)

export default component.exports